"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Error = require("./src/error");
var AddToCart = require("./src/addToCart");
var utility_1 = require("./utility");
$(function () {
    if (utility_1.isMobileOrTable()) {
        var TopCart_Mobile = require("./src/top_mobile");
        TopCart_Mobile.render();
    }
    else {
        var TopCart = require("./src/top");
        TopCart.render();
    }
    Error.render();
    AddToCart.listen();
    utility_1.loadJS("lightbox.min.js", "/msa/parts/plugins/pspparts/lightbox.min.js");
});
